export const actions = {
    setToken(state, token) {
        state.commit('setToken', token);
        window.localStorage.setItem('authToken', token);
    },
    logout(state) {
        state.commit('setToken', null);
        window.localStorage.removeItem('authToken');
    }
}
